import { PriceObject } from "../../types/shared/Pricing";

export const applyPercentages = (
  basePrice: number | undefined,
  price: number,
  percentages: { discount: number; commission?: number }
): PriceObject => {
  const discountAmount = roundPrice(price * (percentages.discount / 100));
  return {
    originalPrice: price,
    basePrice: basePrice,
    price: roundPrice(price - discountAmount),
    discount: discountAmount,
    commission: percentages.commission ? roundPrice(price * (percentages.commission / 100)) : undefined,
    discountPercentage: percentages.discount,
    commissionPercentage: percentages.commission,
  };
};

const roundPrice = (price: number) => Math.round(price * 100) / 100;
